import React, { Component } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { Translation, withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { toast } from "react-toastify";
import { createPerson, getPersonField } from "../../constants/apiParams";
import apiCall, { METHOD } from "../../constants/baseUrl";
import * as actions from "../../constants/mapDispatchToProps";
import * as stateToProps from "../../constants/mapStateToProps";
import { getUserID } from "../../util/utils";
import FieldTypeList from "../GroupDetail/FieldTypeList";

class AddPerson extends Component {
  constructor(props) {
    super(props);

    this.state = {
      status: false,
      isLoading: false,
      fieldList: [],
      fieldDialogStatus: false,
      formField: [],
      first_name: "",
      last_name: "",
      title: "",
      contact_email_business: ""
    };
  }

  updateValueinForm = item => {
    const { formField } = this.state;

    const index = formField.findIndex(field => field.id == item.id);
    formField[index] = {
      ...formField[index],
      ...{ item }
    };

    this.setState({
      formField
    });
  };

  handleAfterCreateApiCall = (data, name, description, paranet_id) => {
    toast.success(this.props.t(data.message));
    let mail = {
      id: data.id,
      name: name,
      description: description,
      list_type_icon: this.state.mailImage,
      list_type_id: this.state.mailId,
      child_element: paranet_id
    };

    this.props.changeRouteStatus(0);
  };

  handleAfterFieldTypeApiCall = data => {

    data.person_data_type_list.map(item => {
      if (item.is_default_custom == 1) {
        item["value"] = "";
        item["is_default_custom"] = 0;
        item["is_default_field"] = 0;
      } else {
        item["value"] = "";
        item["is_default_custom"] = 0;
      }
    });
    this.setState(() => {
      return {
        formField: data.person_data_type_list,
        fieldList: data.person_data_type_list,
      };
    });
  };

  handleFieldDialogStatus = fieldDialogStatus => {
    this.setState({
      fieldDialogStatus
    });
  };

  handleChangeText = (e, item) => {
    let value;
    if (item.field_type == "checkbox") {
      value = e.target.checked;
    } else {
      value = e.target.value;
    }
    item["value"] = value;
    const { formField } = this.state;
    const index = formField.findIndex(field => field.id == item.id);
    formField[index] = {
      ...formField[index],
      ...{ item }
    };

    this.setState({
      formField
    });
  };

  handleStaticField = (e, type) => {
    if (type == "firstName") {
      this.setState({
        first_name: e.target.value
      });
    } else if (type == "lastName") {
      this.setState({
        last_name: e.target.value
      });
    } else if (type == "title") {
      this.setState({
        title: e.target.value
      });
    } else if (type == "businessEmail") {
      this.setState({
        contact_email_business: e.target.value
      });
    }
  };

  handleLoader = status => {
    this.setState(() => {
      return {
        isLoading: status
      };
    });
  };

  handleAfterCreatePerson = data => {
    const {  id, name, email, sort_order, is_valid_email } = data;

    this.setState({
      formField:this.state.fieldList
    });
    let objPerson = {
      id,
      name,
      email,
      is_valid_email,
      sort_order
    };

    toast.success(this.props.t(data.message));
    this.props.history.push(
      "/group-personlist/" + this.props.match.params.group_id
    );
  };

  handleSubmit = values => {
    var regexEmail = /\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
    const {
      first_name,
      last_name,
      title,
      formField,
      contact_email_business
    } = this.state;
    const child_id = this.props.match.params.group_id;

    let formFieldStatus = "",
      boolStringStatus = false;

    formField &&
      formField.map(item => {
        if (
          item.is_default_field == 1 &&
          item.is_required==1 &&
          !item.value &&
          !boolStringStatus
        ) {
          boolStringStatus = true;
          formFieldStatus =
            this.props.t("addNewPerson.generalEmailValidation") + item.name;
        }
      });


    if (!first_name) {
      toast.info(this.props.t("addNewPerson.firstNameValidation"));
    } else if (!last_name) {
      toast.info(this.props.t("addNewPerson.lastNameValidation"));
    } else if (!contact_email_business) {
      toast.info(this.props.t("addNewPerson.emailValidation"));
    } else if (!regexEmail.test(contact_email_business)) {
      toast.info(this.props.t("addNewPerson.validEmailValidation"));
    } else if (formFieldStatus) {
      toast.info(formFieldStatus);
    } else {
      let person_Data = [];

      formField &&
        formField.map(item => {
          if (item.is_default_field == 1) {
            let objPerson = {
              id: item.id,
              value: item.value
            };
            person_Data.push(objPerson);
          }
        });

      person_Data = JSON.stringify(JSON.stringify(person_Data));
      apiCall(
        METHOD.QUERY,
        createPerson(
          getUserID(),
          child_id,
          first_name,
          last_name,
          title,
          person_Data,
          contact_email_business
        ),
        (data) => this.handleAfterCreatePerson(data),
        (isLoading) => this.handleLoader(isLoading),
        (data) => {
          toast.error(this.props.t(data.message));
        }
      );
    }
  };

  componentDidMount() {
    apiCall(
      METHOD.QUERY,
      getPersonField(),
      (data) => {
        this.handleAfterFieldTypeApiCall(data);
      },
      (isLoading) => {},
      (data) => {
        toast.error(this.props.t(data.message));
      }
    );
  }

  render() {
    const { fieldDialogStatus, isLoading, formField, fieldList } = this.state;
    const { changeRouteStatus } = this.props;

    return (
      <Translation ns="translation">
        {(t, { i18n }) => {
          return (
            <div className="wrapper position-relative">
              <React.Fragment>
                <div className="header-bg header-blue sab-header1 sticky-top">
                  <div className="container">
                    <div className="py-2 d-flex align-items-center">
                      {" "}
                      <span
                        className="pointer"
                        onClick={() => changeRouteStatus(0)}
                      >
                        <i className="zmdi zmdi-close zmdi-hc-fw font-30 text-light"></i>
                      </span>
                      {isLoading ? (
                        <div className="btn btn-light font-13 ml-auto pointer disabled">
                          {t("addNewPerson.toSave")}
                          <div className="spinner-border spinner-border-sm ml-1 text-blue">
                            <span className="sr-only">
                              {t("GeneralMessages.loading")}
                            </span>
                          </div>
                        </div>
                      ) : (
                        <div
                          className="btn btn-light font-13 ml-auto pointer"
                          onClick={this.handleSubmit}
                        >
                          {t("addNewPerson.toSave")}
                        </div>
                      )}
                    </div>
                    <div className="text-center mt-4 text-light">
                      <h2 className="m-0 text-light">
                        {t("addNewPerson.topTitle")}
                      </h2>
                    </div>
                  </div>
                </div>

                <div className="middle-section sab-middle-section1">
                  <div className="container my-4 00z-index-99">
                    <form className="login-form">
                      <div className="form-group">
                        <label className="font-14">
                          {t("addNewPerson.firstName")}
                        </label>

                        <input
                          type="text"
                          className="form-control"
                          placeholder={t("addNewPerson.firstNamePlaceHolder")}
                          onChange={e => this.handleStaticField(e, "firstName")}
                          text={this.state.first_name}
                        />
                      </div>

                      <div className="form-group">
                        <label className="font-14">
                          {t("addNewPerson.lastName")}
                        </label>

                        <input
                          type="text"
                          className="form-control"
                          placeholder={t("addNewPerson.lastNamePlaceHolder")}
                          onChange={e => this.handleStaticField(e, "lastName")}
                          text={this.state.last_name}
                        />
                      </div>
                      <div className="form-group">
                        <label className="font-14">
                          {t("addNewPerson.title")}
                        </label>

                        <input
                          type="text"
                          className="form-control"
                          placeholder={t("addNewPerson.titlePlaceHolder")}
                          onChange={e => this.handleStaticField(e, "title")}
                          text={this.state.title}
                        />
                      </div>
                      <div className="form-group">
                        <label className="font-14">
                          {t("addNewPerson.businessEmail")}
                        </label>

                        <input
                          type="text"
                          className="form-control"
                          placeholder={t("addNewPerson.businessPlaceHolder")}
                          onChange={e =>
                            this.handleStaticField(e, "businessEmail")
                          }
                          text={this.state.title}
                        />
                      </div>

                      {formField &&
                        formField.map((item, index) => {
                          const {
                            id,
                            name,
                            description,
                            field_type,
                            is_default_field,
                            is_default_custom,
                            identifier,
                            value
                          } = item;
                          return (
                            <React.Fragment key={index}>
                              {
                                (is_default_field == 1 &&
                                  field_type == "text" && (
                                    <div className="form-group">
                                      <label className="font-14">
                                        {name && name}
                                      </label>

                                      <input
                                        type="text"
                                        className="form-control"
                                        id={id}
                                        placeholder={description && description}
                                        onChange={(e) =>
                                          this.handleChangeText(e, item)
                                        }
                                        text={value}
                                      />
                                    </div>
                                  ))}

                              {
                                (is_default_field == 1 &&
                                  field_type == "email" && (
                                    <div className="form-group">
                                      <label className="font-14">
                                        {name && name}
                                      </label>
                                      <input
                                        type="email"
                                        className="form-control"
                                        id={id}
                                        placeholder={description && description}
                                        onChange={(e) =>
                                          this.handleChangeText(e, item)
                                        }
                                        text={value}
                                      />
                                    </div>
                                  ))}

                              {
                                (is_default_field == 1 &&
                                  field_type == "tel" && (
                                    <div className="form-group">
                                      <label className="font-14">
                                        {name && name}
                                      </label>
                                      <input
                                        type="tel"
                                        className="form-control"
                                        id={id}
                                        placeholder={description && description}
                                        onChange={(e) =>
                                          this.handleChangeText(e, item)
                                        }
                                        text={value}
                                      />
                                    </div>
                                  ))}

                              {
                                (is_default_field == 1 &&
                                  field_type == "link" && (
                                    <div className="form-group">
                                      <label className="font-14">
                                        {name && name}
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id={id}
                                        placeholder={description && description}
                                        onChange={(e) =>
                                          this.handleChangeText(e, item)
                                        }
                                        text={value}
                                      />
                                    </div>
                                  ))}
                              {
                                (is_default_field == 1 &&
                                  field_type == "text_multiline" && (
                                    <div className="form-group">
                                      <label className="font-14">
                                        {name && name}
                                      </label>

                                      <textarea
                                        type="textarea"
                                        className="form-control"
                                        id={id}
                                        placeholder={description && description}
                                        onChange={(e) =>
                                          this.handleChangeText(e, item)
                                        }
                                        text={value}
                                      />
                                    </div>
                                  ))}

                              {
                                (is_default_field == 1 &&
                                  field_type == "checkbox" && (
                                    <div className="form-group">
                                      <input
                                        type="checkbox"
                                        id={id}
                                        className="mr-2"
                                        checked={value}
                                        onChange={(e) =>
                                          this.handleChangeText(e, item)
                                        }
                                      />
                                      <label htmlFor={id}>{name && name}</label>
                                    </div>
                                  ))}
                            </React.Fragment>
                          );
                        })}
                    </form>
                  </div>
                </div>

                <div className="btn-fixed-bottom-custom clearfix z-index-99">
                      <button
                        className="navbar-toggler collapsed float-right"
                        onClick={() => this.handleFieldDialogStatus(true)}
                        type="button"
                        data-toggle="collapse"
                        data-target="#Brand-toggler"
                        aria-controls="Brand-toggler"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                      >
                        <div className={`rounded-40 rounded-blue float-right`}>
                          <i className="zmdi zmdi-plus zmdi-hc-fw font-22"></i>
                        </div>
                      </button>
                    </div>

                    {fieldDialogStatus && (
                      <FieldTypeList
                        handleFieldDialogStatus={this.handleFieldDialogStatus}
                        fieldList={fieldList}
                        addValue={this.updateValueinForm}
                      />
                    )}
              </React.Fragment>
            </div>
          );
        }}
      </Translation>
    );
  }
}

export default connect(
  state =>
    stateToProps.appMapStateToProps(
      [stateToProps.eventListStateToProps],
      state
    ),
  actions.appMapDispatchToProps([
    actions.groupDetailPersonListDispatchToProps,
    actions.asyncApiDispatchToProps
  ])
)(withTranslation()(withRouter(AddPerson)));
